import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import GenericDataTable from "../Shared/DataTable/GenericDataTable.js";

const LegalManufacturersList = ({ globalContext }) => {


    return <>

        <div style={{ display: "flex", flexDirection: "row" }}>
                        
            <div style={{ width: "75%", textAlign: "left" }}>
            </div>

            <div style={{ width: "25%" }}>
                <a href="/your-medboard/product-portfolio/?mode=11" className="btn btn-outline-primary g-font-size-13 g-mb-15 g-pl-12 g-pr-12 g-pt-8 g-pb-8 g-ml-3 g-mr-20 pull-right" style={{ borderRadius: "20px" }} title="See SPPPs">
                    <span className="fas fa-cube g-mr-5"></span>See List of SPPPs
                </a>
            </div>

        </div>

        <GenericDataTable
            columns={[
                
                {
                    key: "Establishment",
                    label: "Legal Manufacturer",
                    sortable: true,
                    size: "250px",

                    render: ({ row, value }) => (
                        <div
                            style={{
                                padding: "12px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            <a
                                //href={`/your-medboard/country-registrations/product-portfolio/product-portfolio-filter/?mode=7&filter=${row.EstablishmentId}`}
                                href={`/your-medboard/products/?filter[LegalManufacturers]=${row.EstablishmentId}`}
                                style={{
                                    color: "#203864",
                                    textDecoration: "none",
                                }}
                            >
                                {value}
                            </a>
                        </div>
                    ),
                },

                {
                    key: "Count",
                    label: "No. of Products",
                    sortable: true,
                    size: "150px",

                    render: ({ row, value }) => (
                        <div
                            style={{
                                padding: "12px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {value}
                        </div>
                    ),
                },
            ]}
            fetchUrl="/umbraco/api/RIMSProducts/OperatorsProducts/"
            enableDelete={false}
            enableExport={false}
            //deleteUrl="/umbraco/api/RIMSProducts/BulkProducts/"
            //exportUrl="/umbraco/api/RIMSProducts/ProductsExport/"
            queryParams={{roleId: 1}}
            //exportFileName={`country-registrations-totals-export.xlsx`}
            rowTitleKey="Establishment"
            searchPlaceholder="Search"
            LoadingComponent={LoadingSpinnerImage}
            showTotalCount={true}
            totalCountUrl="/umbraco/api/RIMSProducts/OperatorsProductsCount/?roleId=1"
        />

    </>


}

export default LegalManufacturersList;